module.exports = __webpack_public_path__ + "7329894c20d5df08.png";